<raksme-instafeed></raksme-instafeed>
<div class="footer-bottom bg-charade col-xs-12 pt-70">
    <raksme-mainfooter></raksme-mainfooter>
    <raksme-copyright></raksme-copyright>
</div>